import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import Button from '@/components/Button/Button'
import BulkActionModal from '@/components/common/BulkActionModal'
import DEFAULT_PAGE_SIZE from '@/constants/default-page-size'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
  count: number
  isRemoveLoading: boolean
  unableToRemoveRooms: {
    name: string
    id: string
  }[]
  onRemove: () => void
}

const PAGE_SIZE = DEFAULT_PAGE_SIZE

const BulkRemoveConfirmModal = (props: Props) => {
  const { t } = useTranslation('rooms')
  const [page, setPage] = useState(1)

  const data = useMemo(() => {
    const startIdx = (page - 1) * PAGE_SIZE
    const endIdx = startIdx + PAGE_SIZE

    return props.unableToRemoveRooms.slice(startIdx, endIdx)
  }, [page, props.unableToRemoveRooms])

  const handleOpenChange = (open: boolean) => {
    if (!open) setPage(1)
    props.onOpenChange(open)
  }

  return (
    <>
      <BulkActionModal
        open={props.open}
        onOpenChange={handleOpenChange}
        unableToPerformActionData={data}
        count={props.unableToRemoveRooms.length}
        page={page}
        pageSize={PAGE_SIZE}
        onPageChange={setPage}
        title={t('header.remove-rooms', { count: props.count })}
        description={
          <>
            <p>
              {t('help.want-to-remove-number-of-rooms', { count: props.count })}
            </p>
            <p>{t('help.contact-administration-team')}</p>
          </>
        }
        alertTitle={t('alert.unable-to-remove-rooms', {
          count: props.unableToRemoveRooms.length
        })}
        alertDescription={t('alert.unable-to-remove-rooms-description')}
        confirmButton={
          <Button
            variant="danger"
            onClick={props.onRemove}
            loading={props.isRemoveLoading}
          >
            {t('button.remove')}
          </Button>
        }
      />
    </>
  )
}

export default BulkRemoveConfirmModal
